import Marquee from "react-fast-marquee";
import { Flame } from "lucide-react";
import ActivityKindIcon, { stripActivityEmoji } from "@/components/ActivityKindIcon";

const KIND_STYLES = {
  whale: "text-sky-400",
  flip: "text-gold",
  new_number_one: "text-gold",
  new_entity: "text-zinc-400",
  contribution: "text-zinc-300",
};

function TickerItem({ ev, className = "" }) {
  const text = stripActivityEmoji(ev.text);
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      <ActivityKindIcon kind={ev.kind} className="h-3 w-3" />
      <span className={KIND_STYLES[ev.kind] || "text-zinc-300"}>{text}</span>
    </span>
  );
}

export default function Ticker({ events }) {
  const items = events && events.length ? events : [{ id: "empty", text: "Be the first to back a token", kind: "contribution" }];
  const primary = items[0];

  return (
    <div className="border-b border-white/10 bg-[#070707]" data-testid="activity-ticker">
      <div className="flex min-w-0 items-center">
        <div className="flex shrink-0 items-center gap-1.5 border-r border-white/10 bg-white px-3 py-2 text-black">
          <Flame className="h-3.5 w-3.5" strokeWidth={2} />
          <span className="text-[10px] font-black uppercase tracking-[0.2em]">Live</span>
        </div>

        {/*
          Ultra-small viewports: react-fast-marquee clones children wider than the
          viewport; overflow:hidden on a wrapper is not enough for scrollWidth audits.
          Show a single truncated static line below sm; animate from sm up.
        */}
        <div className="min-w-0 flex-1 overflow-hidden sm:hidden">
          <p className="truncate whitespace-nowrap py-2 pl-3 font-mono text-xs">
            <TickerItem ev={primary} />
          </p>
        </div>

        <div className="hidden min-w-0 flex-1 overflow-hidden sm:block">
          <Marquee speed={40} gradient={false} pauseOnHover className="py-2">
            {items.concat(items).map((ev, i) => (
              <span key={ev.id + "-" + i} className="mx-6 font-mono text-xs">
                <TickerItem ev={ev} />
              </span>
            ))}
          </Marquee>
        </div>
      </div>
    </div>
  );
}
